import { render } from "./RightWrongBar.vue?vue&type=template&id=74ccd37c&scoped=true&ts=true"
import script from "./RightWrongBar.vue?vue&type=script&lang=ts"
export * from "./RightWrongBar.vue?vue&type=script&lang=ts"

import "./RightWrongBar.vue?vue&type=style&index=0&id=74ccd37c&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ccd37c"]])

export default __exports__